import { Input } from "antd";
import { useEffect, useState } from "react";
import BonusCard from "./BonusCard";
import CommonPopup from "../../components/popup/CommonPopup";
import { IMAGE_BASE_URL } from "../../helpers/constants";

const ViewBonusPopup = (props) => {
  //console.log("PROPS BONUS", props?.bonusData);

  const { allAgent, name, icon, interest, startDate, endDate } =
    props?.bonusData || {};

  // Initialize filterBonus based on props.bonusData.allAgent
  const initialFilterBonus = props?.bonusData?.allAgent || [];

  const [searchTerm, setSearchTerm] = useState("");
  const [filterBonus, setFilterBonus] = useState(initialFilterBonus);

  const handleSearchBonus = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    const filteredAgents = initialFilterBonus.filter((item) => {
      return item.name.toLowerCase().includes(term);
    });

    setFilterBonus(filteredAgents);
  };

  // This useEffect sets the initial filterBonus when allAgent data is available
  useEffect(() => {
    setFilterBonus(initialFilterBonus);
  }, [initialFilterBonus]);

  return (
    <CommonPopup
      size="xlg"
      isOpen={props?.bonusPopUp}
      onClose={() => props.closeBonusPop()}
      title={`Bonus (${allAgent ? allAgent.length : 0})`}
    >
      <div className="relative">
        <div>
          <Input
            prefix={
              <img src="/images/search.svg" alt="search" className="mr-[5px]" />
            }
            placeholder="Search"
            value={searchTerm}
            className="loan_com_search w-full isBorder"
            onChange={handleSearchBonus}
          />
        </div>
        <div className="flex items-center flex-wrap gap-[15px_10px] justify-between py-[20px] sticky top-0 bg-white left-0 z-[10]">
          <div className="flex items-center">
            <div className="mr-[12px]">
              <img
                src={`${IMAGE_BASE_URL}/${icon}`}
                alt="bank logo"
                className="w-[47px] h-[47px] object-contain bg-white rounded-[4px]"
              />
            </div>
            <div>
              <h3 className="text-[#0D062D] font-[700]">{name}</h3>
              <p className="text-[12px] text-[#787486] flex items-center">
                <img
                  src="/images/fi_calendar.svg"
                  alt="calendar"
                  className="mr-[7px]"
                />
                Available from:{" "}
                <strong className="ml-[5px] font-[600] text-[#0F0F0F]">
                  {startDate} <span className="mx-[4px]">to</span>{" "}
                  {endDate ? endDate : "Further Notice"}
                </strong>
              </p>
            </div>
          </div>
          <div>
            <span className="inline-block text-[#0D062D] ml-[5px] font-[800] text-[30px]">
              {interest}%
            </span>
          </div>
        </div>
        {filterBonus.map((item, idx) => {
          //console.log(item);
          return (
            <div
              className="border border-[#E0E0E0] mb-[20px] rounded-[8px] px-[15px] pb-[5px] bg-white relative"
              key={idx}
            >
              <div className="flex items-center py-[15px] sticky top-[87px] bg-white left-0 z-[9]">
                <span>
                  <img
                    src={`${IMAGE_BASE_URL}/${item?.icon}`}
                    alt="agent icon"
                    className="w-[28px] h-[28px] object-contain bg-white rounded-[4px]"
                  />
                </span>
                <span className="text-[#0D062D] text-[14px] font-[700] ml-[8px]">
                  {item?.name}
                </span>
              </div>
              {item.bonuses.length > 0 ? (
                item.bonuses.map((bonus, idx) => {
                  return <BonusCard key={idx} cardData={bonus} />;
                })
              ) : (
                <div className="text-[13px] mt-[10px] mb-[15px] font-[500]">
                  No Bonus Selected
                </div>
              )}
            </div>
          );
        })}
      </div>
    </CommonPopup>
  );
};

export default ViewBonusPopup;
